import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CameraCleanupService {
  private activeStreams: MediaStream[] = [];

  registerStream(stream: MediaStream): void {
    this.activeStreams.push(stream);
  }

  unregisterStream(stream: MediaStream): void {
    const index = this.activeStreams.indexOf(stream);
    if (index > -1) {
      this.activeStreams.splice(index, 1);
    }
  }

  stopAllMediaStreams(): void {
    this.activeStreams.forEach((stream) => {
      stream.getTracks().forEach((track) => {
        track.stop();
      });
    });
    this.activeStreams = [];
    const videoElements = document.querySelectorAll('video');
    videoElements.forEach((video) => {
      if (video.srcObject) {
        const stream = video.srcObject as MediaStream;
        if (stream && stream.getTracks) {
          const tracks = stream.getTracks();
          tracks.forEach((track) => {
            if (track.readyState === 'live') {
              track.enabled = false;
              track.stop();
            }
          });
        }
        video.srcObject = null;
        video.pause();
        video.load();
      }
    });

    videoElements.forEach((video) => {
      try {
        video.pause();
        video.removeAttribute('src');
        video.load();
      } catch (error) {
        console.warn('[CameraCleanup] Error in additional cleanup:', error);
      }
    });
  }

  checkActiveStreams(): boolean {
    const videoElements = document.querySelectorAll('video');
    let hasActiveStreams = false;
    videoElements.forEach((video) => {
      if (video.srcObject) {
        const stream = video.srcObject as MediaStream;
        if (stream && stream.getTracks) {
          const activeTracks = stream.getTracks().filter((track) => track.readyState === 'live');
          if (activeTracks.length > 0) {
            hasActiveStreams = true;
          }
        }
      }
    });
    return hasActiveStreams;
  }
}
